<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Edit Personnel Records</h5>

    <form [formGroup]="Form_List_Hasilat_Record" (submit)="onSubmitTahsimla()">
      <h4>Education</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">From Year/Month</label>
          <input formControlName="date_starrt" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Hasilat_Record_date_starrt().valid && get_Form_List_Hasilat_Record_date_starrt().touched"
            class="form-text text-muted MyErrorRedColor">Enter the start year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">To Year/Month</label>
          <input formControlName="date_end" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Hasilat_Record_date_end().valid && get_Form_List_Hasilat_Record_date_end().touched"
            class="form-text text-muted MyErrorRedColor">Enter the end year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Degree Level</label>
          <input formControlName="degree" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Hasilat_Record_degree().valid && get_Form_List_Hasilat_Record_degree().touched"
            class="form-text text-muted MyErrorRedColor">Enter the degree level.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Field of Study</label>
          <input formControlName="reshteh" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Hasilat_Record_reshteh().valid && get_Form_List_Hasilat_Record_reshteh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the field of study.</small>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Specialization</label>
          <input formControlName="grayesh" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Hasilat_Record_grayesh().valid && get_Form_List_Hasilat_Record_grayesh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the specialization.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">University/Higher Education Institution</label>
          <input formControlName="uni" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Hasilat_Record_uni().valid && get_Form_List_Hasilat_Record_uni().touched"
            class="form-text text-muted MyErrorRedColor">Enter the university or higher education institution.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Grade Point Average</label>
          <input formControlName="moadel" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Hasilat_Record_moadel().valid && get_Form_List_Hasilat_Record_moadel().touched"
            class="form-text text-muted MyErrorRedColor">Enter the grade point average.</small>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            Upload Education Certificate
            <button (click)="Remove_uploadax_Hasilat_Image()" type="button" *ngIf="ax_Hasilat_Image"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Hasilat_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Hasilat_Image" #file_ax_Hasilat_Image
            (change)="uploadax_Hasilat_Image(file_ax_Hasilat_Image.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,ax_Hasilat_Image)" *ngIf="ax_Hasilat_Image"
            style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Hasilat_Image}}" />
        </div>
      </div>

      <button type="submit" [disabled]="!Form_List_Hasilat_Record.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Education Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Tahsilat_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>From Year/Month</th>
            <th>To Year/Month</th>
            <th>Degree Level</th>
            <th>Field of Study</th>
            <th>Specialization</th>
            <th>University/Higher Education Institution</th>
            <th>Grade Point Average</th>
            <th>Education Certificate</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Tahsilat_List">
            <td>{{Data_Tahsilat_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.degree}}</td>
            <td>{{item.reshteh}}</td>
            <td>{{item.grayesh}}</td>
            <td>{{item.uni}}</td>
            <td>{{item.moadel}}</td>
            <td>
              <img (click)="openModal(templateImage,item.image)" *ngIf="item.image"
                style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}" />
            </td>

            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveTahsimla(Data_Tahsilat_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_kari_Record" (submit)="onSubmitkari()">
      <h4>Employment History (Past 5 Years)</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">From Year/Month</label>
          <input formControlName="date_starrt" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_kari_Record_date_starrt().valid && get_Form_List_kari_Record_date_starrt().touched"
            class="form-text text-muted MyErrorRedColor">Enter the start year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">To Year/Month</label>
          <input formControlName="date_end" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_date_end().valid && get_Form_List_kari_Record_date_end().touched"
            class="form-text text-muted MyErrorRedColor">Enter the end year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Company/Organization Name</label>
          <input formControlName="companyName" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_kari_Record_companyName().valid && get_Form_List_kari_Record_companyName().touched"
            class="form-text text-muted MyErrorRedColor">Enter the company or organization name.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Employment Type</label>
          <input formControlName="type" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_type().valid && get_Form_List_kari_Record_type().touched"
            class="form-text text-muted MyErrorRedColor">Enter the employment type.</small>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Position</label>
          <input formControlName="semat" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_semat().valid && get_Form_List_kari_Record_semat().touched"
            class="form-text text-muted MyErrorRedColor">Enter the position.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Reason for Leaving</label>
          <input formControlName="leave" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_leave().valid && get_Form_List_kari_Record_leave().touched"
            class="form-text text-muted MyErrorRedColor">Enter the reason for leaving.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Phone</label>
          <input formControlName="tel" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_tel().valid && get_Form_List_kari_Record_tel().touched"
            class="form-text text-muted MyErrorRedColor">Enter the phone number.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Address</label>
          <input formControlName="address" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_kari_Record_address().valid && get_Form_List_kari_Record_address().touched"
            class="form-text text-muted MyErrorRedColor">Enter the address.</small>
        </div>
      </div>

      <button type="submit" [disabled]="!Form_List_kari_Record.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Employment Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Kari_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>From Year/Month</th>
            <th>To Year/Month</th>
            <th>Company/Organization Name</th>
            <th>Employment Type</th>
            <th>Position</th>
            <th>Reason for Leaving</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Kari_List">
            <td>{{Data_Kari_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.companyName}}</td>
            <td>{{item.type}}</td>
            <td>{{item.semat}}</td>
            <td>{{item.leave}}</td>
            <td>{{item.tel}}</td>
            <td>{{item.address}}</td>

            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveKari(Data_Kari_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Amoozeshi_Record" (submit)="onSubmitAmozeshi()">
      <h4>Training Records</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">From Year/Month</label>
          <input formControlName="date_starrt" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Amoozeshi_Record_date_starrt().valid && get_Form_List_Amoozeshi_Record_date_starrt().touched"
            class="form-text text-muted MyErrorRedColor">Enter the start year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">To Year/Month</label>
          <input formControlName="date_end" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Amoozeshi_Record_date_end().valid && get_Form_List_Amoozeshi_Record_date_end().touched"
            class="form-text text-muted MyErrorRedColor">Enter the end year/month.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Training Syllabus</label>
          <select class="custom-select" formControlName="sarFaslAmozeshi_id" (change)="ReadData_DorehAmoozeshi()">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_SarFaslAmozeshi" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Training Course Title</label>
          <select class="custom-select" formControlName="dorehAmoozeshi_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_DorehAmoozeshi" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Duration (Hours)</label>
          <input formControlName="modat" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Amoozeshi_Record_modat().valid && get_Form_List_Amoozeshi_Record_modat().touched"
            class="form-text text-muted MyErrorRedColor">Enter the duration in hours.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Training Provider</label>
          <input formControlName="bargozarKonnadeh" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Amoozeshi_Record_bargozarKonnadeh().valid && get_Form_List_Amoozeshi_Record_bargozarKonnadeh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the training provider.</small>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            Upload Education Certificate
            <button (click)="Remove_uploadax_Amoozeshi_Image()" type="button" *ngIf="ax_Amoozeshi_Image"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Amoozeshi_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Amoozeshi_Image" #file_ax_Amoozeshi_Image
            (change)="uploadax_Amoozeshi_Image(file_ax_Amoozeshi_Image.files)" type="file" class="form-control"
            placeholder="Type here...">
          <img (click)="openModal(templateImage,ax_Amoozeshi_Image)" *ngIf="ax_Amoozeshi_Image"
            style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Amoozeshi_Image}}" />
        </div>
      </div>

      <button type="submit" [disabled]="!Form_List_Amoozeshi_Record.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Training Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Amoozeshi_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>From Year/Month</th>
            <th>To Year/Month</th>
            <th>Training Syllabus</th>
            <th>Training Course Title</th>
            <th>Duration (Hours)</th>
            <th>Training Provider</th>
            <th>Education Certificate</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Amoozeshi_List">
            <td>{{Data_Amoozeshi_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.sarFaslAmozeshiTitle}}</td>
            <td>{{item.dorehAmoozeshiTitle}}</td>
            <td>{{item.modat}}</td>
            <td>{{item.bargozarKonnadeh}}</td>
            <td>
              <a target="_blank" *ngIf="item.image && item.image.includes('.pdf')" href="{{BaseUrl}}File/Person/{{item.image}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                <img *ngIf="item.image && !item.image.includes('.pdf')" (click)="openModal(templateImage,item.image)"  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}"/>
            </td>

            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveAmozeshi(Data_Amoozeshi_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Skill_Record" (submit)="onSubmitSkill()">
      <h4>Skill</h4>
      <br>
      <div class="row">

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Skill</label>
          <select class="custom-select" formControlName="skill">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Skill" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Percentage</label>
          <input formControlName="percent" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Skill_Record_percent().valid && get_Form_List_Skill_Record_percent().touched"
            class="form-text text-muted MyErrorRedColor">Enter the percentage.</small>
        </div>

      </div>

      <button type="submit" [disabled]="!Form_List_Skill_Record.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Skill </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Skill_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Skill</th>
            <th>Percentage</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Skill_List">
            <td>{{Data_Skill_List.indexOf(item)+1}}</td>
            <td>{{item.skillTitle}}</td>
            <td>{{item.percennt}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveSkill(Data_Skill_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Tahghighat_Record" (submit)="onSubmitTahghighat()">
      <h4>Research</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Title</label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Tahghighat_Record_title().valid && get_Form_List_Tahghighat_Record_title().touched"
            class="form-text text-muted MyErrorRedColor">Enter the title.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Date</label>
          <input formControlName="tarikh" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Tahghighat_Record_tarikh().valid && get_Form_List_Tahghighat_Record_tarikh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the date.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Publisher</label>
          <input formControlName="nasher" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Tahghighat_Record_nasher().valid && get_Form_List_Tahghighat_Record_nasher().touched"
            class="form-text text-muted MyErrorRedColor">Enter the publisher.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Link</label>
          <input formControlName="link" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_List_Tahghighat_Record_link().valid && get_Form_List_Tahghighat_Record_link().touched"
            class="form-text text-muted MyErrorRedColor">Enter the link.</small>
        </div>

      </div>

      <button type="submit" [disabled]="!Form_List_Tahghighat_Record.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Research Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Tahghighat_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Date</th>
            <th>Publisher</th>
            <th>Link</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Tahghighat_List">
            <td>{{Data_Tahghighat_List.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.tarikh}}</td>
            <td>{{item.nasher}}</td>
            <td>{{item.link}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveTahghighat(Data_Tahghighat_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Document_Record" (submit)="onSubmitDocument()">
      <h4>Document Review and Understanding</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Document Group</label>
          <select class="custom-select" formControlName="grpDoc_id" (change)="ReadData_DocumentTitle()">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_DocumentGroup" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Document Title</label>
          <select class="custom-select" formControlName="tlDoc_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_DocumentTitle" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Revision Number</label>
          <input formControlName="shomareh" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Document_Record_shomareh().valid && get_Form_List_Document_Record_shomareh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the revision number.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Approver</label>
          <input formControlName="taminKonandeh" type="text" class="form-control" placeholder="Type here...">
          <small
            *ngIf="!get_Form_List_Document_Record_taminKonandeh().valid && get_Form_List_Document_Record_taminKonandeh().touched"
            class="form-text text-muted MyErrorRedColor">Enter the approver.</small>
        </div>

      </div>

      <button type="submit" [disabled]="!Form_List_Document_Record.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Document Review Record </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Document_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Document Group</th>
            <th>Document Title</th>
            <th>Revision Number</th>
            <th>Approver</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Document_List">
            <td>{{Data_Document_List.indexOf(item)+1}}</td>
            <td>{{item.grpDocTitle}}</td>
            <td>{{item.tlDocTitle}}</td>
            <td>{{item.shomareh}}</td>
            <td>{{item.taminKonandeh}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveDocument(Data_Document_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" type="button" (click)="SubmitEditNewPerson()"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
        class="fa fa-times-rectangle"></i> Cancel </button>
    <button routerLink="/Person1" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> Back </button>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Person/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Person/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
